export function isBrowser() {
    try {
        return typeof window !== "undefined";
    } catch (error) {
        return false;
    }
}
